import styled from "@emotion/styled"

const ArticleAsideSpinnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export default ArticleAsideSpinnerWrapper
